/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  BuiltinExclusionCategory,
  BuiltinExclusionCategory$inboundSchema,
} from "./builtinexclusioncategory.js";

export type ListBuiltinExclusionsResult = {
  /**
   * The library grouped by category.
   */
  categories: Array<BuiltinExclusionCategory>;
  /**
   * Catalog checksum/version, for provenance.
   */
  version: string;
};

/** @internal */
export const ListBuiltinExclusionsResult$inboundSchema: z.ZodMiniType<
  ListBuiltinExclusionsResult,
  unknown
> = z.object({
  categories: z.array(BuiltinExclusionCategory$inboundSchema),
  version: z.string(),
});

export function listBuiltinExclusionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListBuiltinExclusionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListBuiltinExclusionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListBuiltinExclusionsResult' from JSON`,
  );
}
